import { render } from "./EduModule.vue?vue&type=template&id=363dfc20"
import script from "./EduModule.vue?vue&type=script&lang=js"
export * from "./EduModule.vue?vue&type=script&lang=js"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__